/**
* @author 贝才[beica1@outook.com]
* @date 2021/4/15
* @description
*   Locale.vue of WeTrade
*/
<template>
  <PageWithHeader class="bg-white" useFooter>
    <template #title>
      <t path="language_2">Language</t>
    </template>
    <template #body>
      <div style="padding:20px 100px;min-height: 690px;">
        <div
          v-for="locale in locales" :key="locale.i18nPath" class="option df-middle"
          :class="{active: locale.lang === lang}"
          @click="changeLanguage(locale.lang)"
          style="cursor: pointer"
        >
          <Pic :src="`flag/${locale.flag}`" width="24" height="24" />
          <p class="flex-1 ml-16">{{locale.label}}</p>
          <Icon v-if="locale.lang === lang" name="check" class="check" sm />
        </div>
      </div>
    </template>
    <template #footer>
      <Button class="primary" style="padding: 0 30px;" @click="saveClick">
        <t path="live_13">Save</t>
      </Button>
    </template>
  </PageWithHeader>
</template>

<script lang="ts">
import { switchLanguage } from '@/modules/app/app'
import Icon from '@/components/Icon.vue'
import Pic from '@/components/Pic.vue'
import i18n, { languages } from '@/i18n'
import PageWithHeader from '@/provider/PageWithHeader.vue'
import { defineComponent, shallowRef } from 'vue'
import { useRouter } from 'vue-router'
import Button from '@/components/Button.vue'

export default defineComponent({
  name: 'Locale',
  components: { Icon, Pic, PageWithHeader, Button },
  setup () {
    const router = useRouter()
    const lang = shallowRef(i18n.locale.value)

    const changeLanguage = (clang: string) => {
      lang.value = clang
    }
    const saveClick = () => {
      console.log(lang)
      switchLanguage(lang.value).then(router.back)
    }
    return {
      lang,
      locales: languages,
      changeLanguage,
      saveClick,
    }
  },
})
</script>

<style scoped lang="scss">
.option {
  height: 40px;
  margin-top: 8px;
  padding: 0 24px;
  border-radius: 2px;
  border: 1px solid transparent;
  background: var(--color-light);

  &.active {
    background: #E6EDFE;
  }
}

.check {
  border-radius: 8px;
  color: var(--color-white);
  background: var(--color-primary);
}
</style>
